var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-models" },
    [
      _vm.ragMethod !== "supsis-rag"
        ? [
            _c("div", { staticClass: "header" }, [
              _c("h3", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.aiModelsComparison"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.aiModelsChangeModel"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { value: _vm.selectedModel },
                          on: { change: _vm.onChangeSelectedModel },
                        },
                        _vm._l(_vm.models, function (m) {
                          return _c(
                            "a-select-option",
                            { key: m.id, attrs: { value: m.id } },
                            [_vm._v(_vm._s(m.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.saveSelectedModel },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "legend" }, [
                    _c("span", { staticClass: "badge best" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.aiModelsRecommended"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "badge cheap" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.aiModelsEconomic"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "badge codex" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.aiModelsCodex"))),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cards",
                class: { "selection-active": !!_vm.selectedModel },
              },
              _vm._l(_vm.models, function (m) {
                return _c(
                  "div",
                  {
                    key: m.id,
                    staticClass: "card",
                    class: [
                      { "is-selected": _vm.selectedModel === m.id },
                      m.badge ? m.badge : "",
                      "model-" + m.cssClass,
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.onSelect(m.id)
                      },
                    },
                  },
                  [
                    _vm.selectedModel === m.id
                      ? _c("div", { staticClass: "selected-ribbon" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("check_circle"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.selected"))),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-head" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(m.label)),
                      ]),
                      _vm._v(" "),
                      m.badge
                        ? _c("div", { staticClass: "right" }, [
                            _c(
                              "span",
                              { staticClass: "badge", class: m.badge },
                              [_vm._v(_vm._s(_vm.badgeLabel(m.badge)))]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "banner" }, [
                      _c("div", { staticClass: "banner-title" }, [
                        _vm._v(_vm._s(m.label)),
                      ]),
                    ]),
                    _vm._v(" "),
                    m.desc
                      ? _c("div", { staticClass: "desc" }, [
                          _vm._v(_vm._s(m.desc)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "details" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.intelligence"))),
                        ]),
                        _c("span", { staticClass: "dots" }, [
                          _vm._v(_vm._s(_vm.dots(m.intelligence))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.speed"))),
                        ]),
                        _c("span", { staticClass: "dots" }, [
                          _vm._v(_vm._s(_vm.speedDots(m.speed))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.input"))),
                        ]),
                        _c("span", { staticClass: "icons" }, [
                          _c("span", { staticClass: "md-icon" }, [
                            _vm._v("text_fields"),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "md-icon",
                              class: { disabled: !m.inputImage },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  m.inputImage ? "image" : "not_interested"
                                )
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "md-icon disabled" }, [
                            _vm._v("not_interested"),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.output"))),
                        ]),
                        _c("span", { staticClass: "icons" }, [
                          _c("span", { staticClass: "md-icon" }, [
                            _vm._v("text_fields"),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "md-icon",
                              class: { disabled: !m.outputImage },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  m.outputImage ? "image" : "not_interested"
                                )
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "md-icon disabled" }, [
                            _vm._v("not_interested"),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.reasoningTokens"))),
                        ]),
                        _c("span", { staticClass: "icons" }, [
                          _vm._v(_vm._s(m.reasoning ? "✔️" : "✖️")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pricing-block" }, [
                        _c("div", { staticClass: "block-title" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.pricing")) + " "),
                          _c("span", { staticClass: "muted" }, [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.per1mTokens"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-row" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.input"))),
                          ]),
                          _c("span", [_vm._v(_vm._s(m.priceInput || "—"))]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-row" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.cachedInput"))),
                          ]),
                          _c("span", [_vm._v(_vm._s(m.priceCached || "—"))]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-row" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.output"))),
                          ]),
                          _c("span", [_vm._v(_vm._s(m.priceOutput || "—"))]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "context-block" }, [
                        _c("div", { staticClass: "block-title" }, [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.context"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-row" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.window"))),
                          ]),
                          _c("span", [_vm._v(_vm._s(m.contextWindow || "—"))]),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "disclaimer" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.modelsDisclaimer"))),
            ]),
          ]
        : [
            _c(
              "div",
              { staticClass: "or-page" },
              [
                _c("div", { staticClass: "or-topbar" }, [
                  _c("div", { staticClass: "or-topbar-left" }, [
                    _c("h3", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.llmModelOpenRouter"))),
                    ]),
                    _vm._v(" "),
                    _vm.autoRouterEnabled
                      ? _c(
                          "div",
                          { staticClass: "or-selected-badge" },
                          [
                            _c("span", { staticClass: "selected-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("chatbotv2.activeModel")) + ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b", { staticClass: "selected-model-name" }, [
                              _vm._v("openrouter/auto"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-tag",
                              {
                                staticStyle: {
                                  "margin-left": "4px",
                                  "font-size": "11px",
                                },
                                attrs: { color: "cyan" },
                              },
                              [_vm._v("Auto Router")]
                            ),
                          ],
                          1
                        )
                      : _vm.selectedORModel
                      ? _c("div", { staticClass: "or-selected-badge" }, [
                          _c("span", { staticClass: "selected-label" }, [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.selected")) + ":"),
                          ]),
                          _vm._v(" "),
                          _c("b", { staticClass: "selected-model-name" }, [
                            _vm._v(_vm._s(_vm.selectedORModel)),
                          ]),
                          _vm._v(" "),
                          _vm.selectedORModelHasToolsWarning
                            ? _c("span", { staticClass: "tools-warn-inline" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("warning"),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("chatbotv2.toolsNotSupported")
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "or-topbar-right" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.saving,
                            disabled:
                              !_vm.selectedORModel || _vm.autoRouterEnabled,
                          },
                          on: { click: _vm.saveORModel },
                        },
                        [_vm._v(_vm._s(_vm.$t("message.save")))]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.autoRouterEnabled
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "10px" } },
                      [
                        _c(
                          "a-alert",
                          { attrs: { type: "info", "show-icon": "" } },
                          [
                            _c("template", { slot: "message" }, [
                              _c("b", [_vm._v("Auto Router Aktif")]),
                              _vm._v(
                                " — Model seçimi devre dışı\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("template", { slot: "description" }, [
                              _c("b", [_vm._v("Plugins > Auto Router")]),
                              _vm._v(" açık olduğu için primary model olarak "),
                              _c("code", [_vm._v("openrouter/auto")]),
                              _vm._v(
                                " kullanılmaktadır.\n                        Her istek için en uygun model NotDiamond tarafından otomatik seçilir.\n                        Model değiştirmek istiyorsanız önce "
                              ),
                              _c("b", [_vm._v("Plugins")]),
                              _vm._v(
                                " sayfasından Auto Router'ı kapatın.\n                    "
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.orError
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "10px" } },
                      [
                        _c("a-alert", {
                          attrs: {
                            type: "error",
                            message: _vm.orError,
                            "show-icon": "",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.chatbotHasTools &&
                _vm.selectedORModel &&
                _vm.selectedORModelHasToolsWarning
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "10px" } },
                      [
                        _c(
                          "a-alert",
                          { attrs: { type: "warning", "show-icon": "" } },
                          [
                            _c("template", { slot: "message" }, [
                              _vm._v("\n                        Seçili model "),
                              _c("b", [_vm._v("tools")]),
                              _vm._v(
                                " parametresini desteklemiyor — chatbot'unuzda fonksiyon/araç aktif.\n                        Aşağıdan "
                              ),
                              _c("b", [_vm._v("tools destekleyen")]),
                              _vm._v(
                                " bir fallback model seçin.\n                    "
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isByokChannel
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "10px" } },
                      [
                        _c("a-alert", {
                          attrs: {
                            type: "warning",
                            "show-icon": "",
                            message:
                              "BYOK Mod Aktif — Fiyatlara %10 Supsis hizmet ücreti eklenir.",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "or-routing-config" }, [
                  _c(
                    "div",
                    { staticClass: "or-config-block or-config-block--routing" },
                    [
                      _c("div", { staticClass: "or-config-block__header" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "or-config-block__titles" }, [
                          _c(
                            "span",
                            { staticClass: "or-config-block__title" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("chatbotv2.routingStrategy"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "or-config-block__subtitle" },
                            [_vm._v("OpenRouter")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "or-config-block__body" },
                        [
                          _c(
                            "a-radio-group",
                            {
                              staticClass: "or-routing-radio-group",
                              attrs: { size: "small" },
                              model: {
                                value: _vm.orRoutingStrategy,
                                callback: function ($$v) {
                                  _vm.orRoutingStrategy = $$v
                                },
                                expression: "orRoutingStrategy",
                              },
                            },
                            [
                              _c(
                                "a-radio-button",
                                { attrs: { value: "default" } },
                                [_vm._v("Fiyat Dengeli")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-radio-button",
                                { attrs: { value: "price" } },
                                [_vm._v("En Ucuz")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-radio-button",
                                { attrs: { value: "throughput" } },
                                [_vm._v("En Hızlı")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-radio-button",
                                { attrs: { value: "latency" } },
                                [_vm._v("En Düşük Gecikme")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "or-config-split" }, [
                    _c(
                      "div",
                      { staticClass: "or-config-block or-config-block--panel" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "or-config-block__header or-config-block__header--compact",
                          },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "or-config-block__titles" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "or-config-block__title" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("chatbotv2.fallbackModels"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "or-config-block__desc" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("chatbotv2.fallbackModelsDesc")
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "or-config-block__body" },
                          [
                            _c(
                              "a-select",
                              {
                                staticClass: "or-config-full-select",
                                attrs: {
                                  mode: "multiple",
                                  placeholder: _vm.$t(
                                    "chatbotv2.fallbackModelsDesc"
                                  ),
                                  "filter-option": _vm.orFallbackFilter,
                                },
                                model: {
                                  value: _vm.selectedORFallbacks,
                                  callback: function ($$v) {
                                    _vm.selectedORFallbacks = $$v
                                  },
                                  expression: "selectedORFallbacks",
                                },
                              },
                              _vm._l(
                                _vm.filteredORModels.slice(0, 100),
                                function (m) {
                                  return _c(
                                    "a-select-option",
                                    { key: m.id, attrs: { value: m.id } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(m.id) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                            _vm._v(" "),
                            _vm.chatbotHasTools &&
                            _vm.selectedORFallbacks.length === 0 &&
                            _vm.selectedORModelHasToolsWarning
                              ? _c(
                                  "div",
                                  { staticClass: "or-config-inline-warn" },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("warning"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "Tools destekleyen bir fallback model gerekli"
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "or-config-block or-config-block--panel" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "or-config-block__header or-config-block__header--compact",
                          },
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "or-config-block__titles" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "or-config-title-with-help" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "or-config-block__title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "chatbotv2.reasoningEffortLabel"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-tooltip",
                                      {
                                        attrs: {
                                          placement: "topLeft",
                                          overlayClassName:
                                            "or-reasoning-tooltip-popover",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "or-reasoning-tooltip-body",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "chatbotv2.reasoningEffortTooltip"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "or-reasoning-help-trigger",
                                            attrs: {
                                              role: "button",
                                              tabindex: "0",
                                              "aria-label": _vm.$t(
                                                "chatbotv2.reasoningEffortTooltipAria"
                                              ),
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("help_outline")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "or-config-block__desc" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("chatbotv2.reasoningEffortHint")
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "or-config-block__body" },
                          [
                            _c(
                              "a-select",
                              {
                                staticClass:
                                  "or-config-full-select or-config-full-select--reasoning",
                                model: {
                                  value: _vm.orReasoningEffort,
                                  callback: function ($$v) {
                                    _vm.orReasoningEffort = $$v
                                  },
                                  expression: "orReasoningEffort",
                                },
                              },
                              [
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "provider_default" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "chatbotv2.reasoningEffortOptionProviderDefault"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "xhigh" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "chatbotv2.reasoningEffortOptionXhigh"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "high" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "chatbotv2.reasoningEffortOptionHigh"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "medium" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "chatbotv2.reasoningEffortOptionMedium"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "low" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "chatbotv2.reasoningEffortOptionLow"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "minimal" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "chatbotv2.reasoningEffortOptionMinimal"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "none" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "chatbotv2.reasoningEffortOptionNone"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.showOpenaiServiceTier
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "or-config-block or-config-block--service-tier",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "or-config-block__header or-config-block__header--compact",
                            },
                            [
                              _vm._m(3),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "or-config-block__titles" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "or-config-title-with-help",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "or-config-block__title",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "chatbotv2.serviceTierLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "or-reasoning-help-trigger",
                                          attrs: {
                                            role: "button",
                                            tabindex: "0",
                                            "aria-label": _vm.$t(
                                              "chatbotv2.serviceTierHelpAria"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              _vm.serviceTierHelpVisible = true
                                            },
                                            keyup: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              _vm.serviceTierHelpVisible = true
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("help_outline")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "or-config-block__desc" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("chatbotv2.serviceTierHint")
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "or-config-block__body" },
                            [
                              _c(
                                "a-select",
                                {
                                  staticClass: "or-config-full-select",
                                  model: {
                                    value: _vm.orOpenrouterServiceTier,
                                    callback: function ($$v) {
                                      _vm.orOpenrouterServiceTier = $$v
                                    },
                                    expression: "orOpenrouterServiceTier",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "default" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbotv2.serviceTierOptionDefault"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "auto" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbotv2.serviceTierOptionAuto"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "flex" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbotv2.serviceTierOptionFlex"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "priority" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbotv2.serviceTierOptionPriority"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "scale" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbotv2.serviceTierOptionScale"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "a-modal",
                  {
                    attrs: {
                      visible: _vm.serviceTierHelpVisible,
                      title: _vm.$t("chatbotv2.serviceTierHelpTitle"),
                      okText: _vm.$t("chatbotv2.serviceTierModalOk"),
                      width: "580px",
                      wrapClassName: "or-service-tier-help-modal",
                    },
                    on: {
                      ok: function ($event) {
                        _vm.serviceTierHelpVisible = false
                      },
                      cancel: function ($event) {
                        _vm.serviceTierHelpVisible = false
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "or-service-tier-modal-content" },
                      [
                        _c("p", { staticClass: "or-service-tier-modal-p" }, [
                          _vm._v(
                            _vm._s(_vm.$t("chatbotv2.serviceTierHelpIntro"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "or-service-tier-modal-p or-service-tier-modal-p--pre",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.serviceTierHelpBody"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "or-service-tier-modal-links" },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://openrouter.ai/docs/api/api-reference/chat/send-chat-completion-request#request.body.service_tier",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "chatbotv2.serviceTierHelpOpenRouterLink"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "or-service-tier-modal-sep" },
                              [_vm._v("·")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://developers.openai.com/api/docs/pricing",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "chatbotv2.serviceTierOpenAiPricingLink"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.enrichedProviders.length > 0
                  ? _c("div", { staticClass: "or-provider-strip" }, [
                      _c("div", { staticClass: "strip-header" }, [
                        _c("span", { staticClass: "strip-label" }, [
                          _vm._v("Provider"),
                        ]),
                        _vm._v(" "),
                        _vm.filterProviders.length > 0
                          ? _c(
                              "span",
                              {
                                staticClass: "strip-clear",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.clearProviderFilter.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "Temizle (" +
                                    _vm._s(_vm.filterProviders.length) +
                                    ")"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "strip-scroll-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "strip-scroll" },
                          _vm._l(_vm.enrichedProviders, function (prov) {
                            return _c(
                              "a-tooltip",
                              {
                                key: prov.slug,
                                attrs: {
                                  title: prov.displayName,
                                  placement: "bottom",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "strip-chip",
                                    class: {
                                      active:
                                        _vm.filterProviders.indexOf(
                                          prov.slug
                                        ) !== -1,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleProvider(prov.slug)
                                      },
                                    },
                                  },
                                  [
                                    prov.icon
                                      ? _c("img", {
                                          staticClass: "strip-icon",
                                          attrs: {
                                            src: prov.icon,
                                            alt: prov.displayName,
                                          },
                                          on: {
                                            error: function ($event) {
                                              return _vm.onProviderIconError(
                                                $event
                                              )
                                            },
                                          },
                                        })
                                      : _c(
                                          "span",
                                          { staticClass: "strip-fallback" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                prov.displayName
                                                  .slice(0, 2)
                                                  .toUpperCase()
                                              )
                                            ),
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "strip-name" }, [
                                      _vm._v(_vm._s(prov.displayName)),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.orLoading
                  ? _c(
                      "div",
                      { staticClass: "or-loading" },
                      [
                        _c("a-spin", {
                          attrs: { tip: "Modeller yükleniyor..." },
                        }),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "or-main-layout" }, [
                      _c(
                        "div",
                        {
                          staticClass: "or-sidebar",
                          class: { "is-closed": !_vm.sidebarOpen },
                        },
                        [
                          _c("div", { staticClass: "or-sidebar-inner" }, [
                            _c(
                              "div",
                              { staticClass: "sidebar-search" },
                              [
                                _c(
                                  "a-input",
                                  {
                                    attrs: {
                                      placeholder: "Model ara...",
                                      "allow-clear": "",
                                    },
                                    on: { change: _vm.filterORModels },
                                    model: {
                                      value: _vm.orSearchQuery,
                                      callback: function ($$v) {
                                        _vm.orSearchQuery = $$v
                                      },
                                      expression: "orSearchQuery",
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "material-icons",
                                        staticStyle: {
                                          "font-size": "16px",
                                          color: "#bbb",
                                          "line-height": "1",
                                        },
                                        attrs: { slot: "prefix" },
                                        slot: "prefix",
                                      },
                                      [_vm._v("search")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter-section" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "filter-section-header",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleSection("input")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "section-title-wrap" },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons section-icon",
                                        },
                                        [_vm._v("input")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Input Modalities")]),
                                      _vm._v(" "),
                                      _vm.filterInputModalities.length > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "section-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterInputModalities
                                                    .length
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons section-chevron",
                                      class: { open: _vm.openSections.input },
                                    },
                                    [_vm._v("expand_more")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.openSections.input,
                                      expression: "openSections.input",
                                    },
                                  ],
                                  staticClass: "filter-section-body",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "modality-mandatory-row" },
                                    [
                                      _c(
                                        "a-tooltip",
                                        {
                                          attrs: {
                                            title:
                                              "Tüm modeller metin girişi destekler. Chatbot'un çalışması için zorunludur.",
                                            placement: "right",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "mod-chip active" },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("text_fields")]
                                              ),
                                              _vm._v(" Text"),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "mandatory-tag" },
                                        [_vm._v("Zorunlu")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.inputModalityOptions,
                                    function (mod) {
                                      return _c(
                                        "a-tooltip",
                                        {
                                          key: mod.value,
                                          attrs: {
                                            title: mod.tooltip,
                                            placement: "right",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass: "modality-row",
                                              class: {
                                                active:
                                                  _vm.filterInputModalities.indexOf(
                                                    mod.value
                                                  ) !== -1,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleInputModality(
                                                    mod.value
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons mod-row-icon",
                                                },
                                                [_vm._v(_vm._s(mod.icon))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "mod-row-label",
                                                },
                                                [_vm._v(_vm._s(mod.label))]
                                              ),
                                              _vm._v(" "),
                                              _vm.filterInputModalities.indexOf(
                                                mod.value
                                              ) !== -1
                                                ? _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons mod-row-check",
                                                    },
                                                    [_vm._v("check")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm._m(4),
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter-section" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "filter-section-header",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleSection("output")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "section-title-wrap" },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons section-icon",
                                        },
                                        [_vm._v("output")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Output Modalities")]),
                                      _vm._v(" "),
                                      _vm.filterOutputModalities.length > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "section-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterOutputModalities
                                                    .length
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons section-chevron",
                                      class: { open: _vm.openSections.output },
                                    },
                                    [_vm._v("expand_more")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.openSections.output,
                                      expression: "openSections.output",
                                    },
                                  ],
                                  staticClass: "filter-section-body",
                                },
                                _vm._l(
                                  _vm.outputModalityOptions,
                                  function (mod) {
                                    return _c(
                                      "a-tooltip",
                                      {
                                        key: mod.value,
                                        attrs: {
                                          title: mod.tooltip,
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "modality-row",
                                            class: {
                                              active:
                                                _vm.filterOutputModalities.indexOf(
                                                  mod.value
                                                ) !== -1,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleOutputModality(
                                                  mod.value
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "material-icons mod-row-icon",
                                              },
                                              [_vm._v(_vm._s(mod.icon))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "mod-row-label" },
                                              [_vm._v(_vm._s(mod.label))]
                                            ),
                                            _vm._v(" "),
                                            _vm.filterOutputModalities.indexOf(
                                              mod.value
                                            ) !== -1
                                              ? _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons mod-row-check",
                                                  },
                                                  [_vm._v("check")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter-section" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "filter-section-header",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleSection("params")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "section-title-wrap" },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons section-icon",
                                        },
                                        [_vm._v("settings")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Supported Parameters"),
                                      ]),
                                      _vm._v(" "),
                                      _vm.filterSupportedParams.length > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "section-badge" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.filterSupportedParams
                                                    .length
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons section-chevron",
                                      class: { open: _vm.openSections.params },
                                    },
                                    [_vm._v("expand_more")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.openSections.params,
                                      expression: "openSections.params",
                                    },
                                  ],
                                  staticClass: "filter-section-body",
                                },
                                [
                                  _vm._l(
                                    _vm.supportedParamOptions,
                                    function (param) {
                                      return _c(
                                        "a-tooltip",
                                        {
                                          key: param.value,
                                          attrs: {
                                            title: param.tooltip,
                                            placement: "right",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass: "modality-row",
                                              class: {
                                                active:
                                                  _vm.filterSupportedParams.indexOf(
                                                    param.value
                                                  ) !== -1,
                                                "row-tools":
                                                  param.value === "tools" &&
                                                  _vm.chatbotHasTools,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleSupportedParam(
                                                    param.value
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons mod-row-icon",
                                                },
                                                [_vm._v(_vm._s(param.icon))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "mod-row-label",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(param.label) +
                                                      "\n                                        "
                                                  ),
                                                  param.value === "tools" &&
                                                  _vm.chatbotHasTools
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "tools-required-dot",
                                                        },
                                                        [_vm._v("●")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.filterSupportedParams.indexOf(
                                                param.value
                                              ) !== -1
                                                ? _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons mod-row-check",
                                                    },
                                                    [_vm._v("check")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.chatbotHasTools
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "filter-hint tools-hint",
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("warning")]
                                          ),
                                          _vm._v(
                                            "\n                                Chatbot fonksiyon kullanıyor — "
                                          ),
                                          _c("b", [_vm._v("tools")]),
                                          _vm._v(
                                            " zorunlu\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter-section" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "filter-section-header",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleSection("context")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "section-title-wrap" },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons section-icon",
                                        },
                                        [_vm._v("straighten")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Context Window")]),
                                      _vm._v(" "),
                                      _vm.filterContextIdx > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "section-badge" },
                                            [_vm._v("min")]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons section-chevron",
                                      class: { open: _vm.openSections.context },
                                    },
                                    [_vm._v("expand_more")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.openSections.context,
                                      expression: "openSections.context",
                                    },
                                  ],
                                  staticClass: "filter-section-body",
                                },
                                [
                                  _c("div", { staticClass: "section-desc" }, [
                                    _vm._v(
                                      "Minimum context penceresi. Uzun belge veya konuşma geçmişi için yüksek context gereklidir."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "slider-wrap" },
                                    [
                                      _c("a-slider", {
                                        attrs: {
                                          min: 0,
                                          max: 9,
                                          marks: _vm.contextMarks,
                                          step: null,
                                        },
                                        on: { change: _vm.filterORModels },
                                        model: {
                                          value: _vm.filterContextIdx,
                                          callback: function ($$v) {
                                            _vm.filterContextIdx = $$v
                                          },
                                          expression: "filterContextIdx",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter-section" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "filter-section-header",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleSection("pricing")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "section-title-wrap" },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons section-icon",
                                        },
                                        [_vm._v("attach_money")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Pricing")]),
                                      _vm._v(" "),
                                      _vm.filterPricingIdx > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "section-badge" },
                                            [_vm._v("max")]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons section-chevron",
                                      class: { open: _vm.openSections.pricing },
                                    },
                                    [_vm._v("expand_more")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.openSections.pricing,
                                      expression: "openSections.pricing",
                                    },
                                  ],
                                  staticClass: "filter-section-body",
                                },
                                [
                                  _c("div", { staticClass: "section-desc" }, [
                                    _vm._v(
                                      "Maksimum input fiyatı ($/1M token). Free = ücretsiz modeller."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "slider-wrap" },
                                    [
                                      _c("a-slider", {
                                        attrs: {
                                          min: 0,
                                          max: 7,
                                          marks: _vm.pricingMarks,
                                          step: null,
                                        },
                                        on: { change: _vm.filterORModels },
                                        model: {
                                          value: _vm.filterPricingIdx,
                                          callback: function ($$v) {
                                            _vm.filterPricingIdx = $$v
                                          },
                                          expression: "filterPricingIdx",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.hasActiveFilters
                              ? _c(
                                  "div",
                                  { staticClass: "sidebar-clear-btn" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: { block: "", size: "small" },
                                        on: { click: _vm.clearAllFilters },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Tüm Filtreleri Temizle\n                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "or-model-area" }, [
                        _c("div", { staticClass: "or-model-area-header" }, [
                          _c("div", { staticClass: "model-area-left" }, [
                            _c(
                              "button",
                              {
                                staticClass: "sidebar-toggle-btn",
                                attrs: {
                                  title: _vm.sidebarOpen
                                    ? "Filtreleri gizle"
                                    : "Filtreleri göster",
                                },
                                on: { click: _vm.toggleSidebar },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.sidebarOpen ? "chevron_left" : "tune"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.sidebarOpen ? "Gizle" : "Filtreler"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.hasActiveFilters && !_vm.sidebarOpen
                                  ? _c("span", {
                                      staticClass: "active-filter-dot",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "model-count" }, [
                              _vm._v(
                                _vm._s(_vm.filteredORModels.length) + " model"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._m(5),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "or-cards",
                            class: {
                              "auto-router-locked": _vm.autoRouterEnabled,
                            },
                          },
                          _vm._l(_vm.paginatedORModels, function (m) {
                            return _c(
                              "div",
                              {
                                key: m.id,
                                staticClass: "or-card",
                                class: {
                                  "is-selected": _vm.selectedORModel === m.id,
                                  "is-fallback":
                                    _vm.selectedORFallbacks.indexOf(m.id) !==
                                    -1,
                                  "is-recommended":
                                    _vm.isRecommendedForChatbot(m),
                                  "has-tools-issue":
                                    _vm.chatbotHasTools &&
                                    !_vm.modelSupportsParam(m, "tools"),
                                  "is-locked": _vm.autoRouterEnabled,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.autoRouterEnabled
                                      ? null
                                      : _vm.selectORModel(m.id)
                                  },
                                },
                              },
                              [
                                _vm.selectedORModel === m.id
                                  ? _c(
                                      "div",
                                      { staticClass: "selected-ribbon" },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("check_circle")]
                                        ),
                                        _vm._v(
                                          " Primary\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm.selectedORFallbacks.indexOf(m.id) !== -1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "selected-ribbon fallback-ribbon",
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("account_tree")]
                                        ),
                                        _vm._v(
                                          " Fallback\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isRecommendedForChatbot(m)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "card-top-badge recommended-badge",
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("star")]
                                        ),
                                        _vm._v(
                                          " Chatbot için önerilir\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm.chatbotHasTools &&
                                    !_vm.modelSupportsParam(m, "tools")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "card-top-badge tools-badge",
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("warning")]
                                        ),
                                        _vm._v(
                                          " Tools yok\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "or-card-provider" }, [
                                  _vm.getEnrichedProviderIcon(m.id)
                                    ? _c("img", {
                                        staticClass: "or-prov-img",
                                        attrs: {
                                          src: _vm.getEnrichedProviderIcon(
                                            m.id
                                          ),
                                          alt: _vm.getProvider(m.id),
                                        },
                                        on: {
                                          error: function ($event) {
                                            return _vm.onProviderIconError(
                                              $event
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "or-prov-name" }, [
                                    _vm._v(
                                      _vm._s(_vm.getEnrichedProviderName(m.id))
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "or-model-name" }, [
                                  _vm._v(_vm._s(m.name || m.id)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "or-model-id" }, [
                                  _vm._v(_vm._s(m.id)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "or-modalities" }, [
                                  _c(
                                    "div",
                                    { staticClass: "mod-row-group" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mod-group-lbl" },
                                        [_vm._v("In")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.getInputModalities(m),
                                        function (mod) {
                                          return _c(
                                            "a-tooltip",
                                            {
                                              key: "in-" + mod,
                                              attrs: {
                                                title: _vm.getModalityTooltip(
                                                  "input",
                                                  mod
                                                ),
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "mod-badge",
                                                  class: "mod-" + mod,
                                                },
                                                [_vm._v(_vm._s(mod))]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mod-row-group" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mod-group-lbl" },
                                        [_vm._v("Out")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.getOutputModalities(m),
                                        function (mod) {
                                          return _c(
                                            "a-tooltip",
                                            {
                                              key: "out-" + mod,
                                              attrs: {
                                                title: _vm.getModalityTooltip(
                                                  "output",
                                                  mod
                                                ),
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "mod-badge out",
                                                  class: "mod-" + mod,
                                                },
                                                [_vm._v(_vm._s(mod))]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "or-params-row" },
                                  _vm._l(_vm.getKeyParams(m), function (param) {
                                    return _c(
                                      "a-tooltip",
                                      {
                                        key: param,
                                        attrs: {
                                          title: _vm.getParamTooltip(param),
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "param-chip",
                                            class: {
                                              "chip-tools": param === "tools",
                                              "chip-tools-warn":
                                                param === "tools" &&
                                                _vm.chatbotHasTools,
                                            },
                                          },
                                          [_vm._v(_vm._s(param))]
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "or-stats" },
                                  [
                                    _c(
                                      "a-tooltip",
                                      {
                                        attrs: {
                                          title:
                                            "Bu modelin işleyebileceği maksimum token sayısı",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        m.context_length
                                          ? _c(
                                              "div",
                                              { staticClass: "or-stat" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "stat-lbl" },
                                                  [_vm._v("Context")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "stat-val" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatContextLength(
                                                          m.context_length
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-tooltip",
                                      {
                                        attrs: {
                                          title:
                                            "Her 1 milyon input token başına ücret",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "or-stat" }, [
                                          _c(
                                            "span",
                                            { staticClass: "stat-lbl" },
                                            [_vm._v("In/1M")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "stat-val" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatPrice(m, "prompt")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-tooltip",
                                      {
                                        attrs: {
                                          title:
                                            "Her 1 milyon output token başına ücret",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "or-stat" }, [
                                          _c(
                                            "span",
                                            { staticClass: "stat-lbl" },
                                            [_vm._v("Out/1M")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "stat-val" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatPrice(
                                                    m,
                                                    "completion"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.filteredORModels.length > _vm.orPageSize
                          ? _c(
                              "div",
                              { staticClass: "or-pagination" },
                              [
                                _c("a-pagination", {
                                  attrs: {
                                    current: _vm.orCurrentPage,
                                    total: _vm.filteredORModels.length,
                                    "page-size": _vm.orPageSize,
                                    size: "small",
                                  },
                                  on: { change: _vm.onORPageChange },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "or-config-block__icon-wrap",
        attrs: { "aria-hidden": "true" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("swap_horiz")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass:
          "or-config-block__icon-wrap or-config-block__icon-wrap--muted",
        attrs: { "aria-hidden": "true" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("account_tree")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass:
          "or-config-block__icon-wrap or-config-block__icon-wrap--muted",
        attrs: { "aria-hidden": "true" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("psychology")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass:
          "or-config-block__icon-wrap or-config-block__icon-wrap--muted",
        attrs: { "aria-hidden": "true" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("layers")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter-hint" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("lightbulb")]),
      _vm._v("\n                                Chatbot için "),
      _c("b", [_vm._v("image + file")]),
      _vm._v(" destekleyen modeller önerilir\n                            "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "recommendation-hint" }, [
      _c("span", { staticClass: "rec-dot" }),
      _vm._v(" "),
      _c("b", [_vm._v("Chatbot için önerilir:")]),
      _vm._v(
        " text + image + file destekleyen modeller\n                        "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }